module.exports = __webpack_public_path__ + "static/img/index_banner4.886b646.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index_banner4.png
// module id = 8su3
// module chunks = 1